import {Component, h} from "preact";
import styles from './style.module.scss';
import {connect} from "redux-zero/preact";
import actions from "../../../../store/actions";
import {QueryState} from "../../../../models/query";
import {icons} from "../../../icons";
import {Image, Product, Variant} from "../../../../models/product";
import App from "../../../app";
import {i18nService} from "../../../../services/i18n-service";
import {navigationService} from "../../../../services/navigation-service";
import {NY_Tracker, TrackingEvent} from "../../../../services/tracking-service";

interface Props {
  loadNext?();

  products?: QueryState;
  product: Product;
  variant: Variant;
}

interface State {
  index: number,
  previousProduct: Variant,
  previousWebCategory: string,
  nextProduct: Variant,
  nextWebCategory: string
}

const mapToProps = ({products}) => ({products});

class Navigation extends Component<Props, State> {

  state = {
    index: -1,
    previousProduct: null,
    previousWebCategory: '',
    nextProduct: null,
    nextWebCategory: '',
  };

  componentDidMount(): void {
    if (this.props.variant) {
      const index: number = this.findInProducts(this.props.variant.productId, this.props.variant.id);
      this._calculatePrevNext(index);
    }
  }

  componentWillReceiveProps(newProps: Props): void {
    if (this.props.variant) {
      if (newProps.variant.productId != this.props.variant.productId || newProps.variant.id != this.props.variant.id) {
        const index: number = this.findInProducts(newProps.variant.productId, newProps.variant.id);
        this._calculatePrevNext(index);
      }
    }
  }

  private _calculatePrevNext(index: number) {
    this._calculatePrevious(index);
    this._calculateNext(index);

    this.setState({
      index: index
    });

    if (this.props.products.items.length === index + 1 && this.props.products.totalCount > this.props.products.items.length) {
      this.props.loadNext();
    }
  }

  render() {
    return (
      <div class={styles['header-container']}>
        <div class={styles.arrows}>
          <span class={`${styles.arrow} ${!this.state.previousProduct ? styles.disabled : ''}`}
                onClick={() => this._handleArrowClick(this.state.previousWebCategory, this.state.previousProduct)}>{icons.renderArrowLeftIcon()}</span>
          <span
            class={`${styles.divider} ${!this.state.previousProduct && !this.state.nextProduct ? styles.disabled : ''}`}>|</span>
          <span class={`${styles.arrow} ${!this.state.nextProduct ? styles.disabled : ''}`}
                onClick={() => this._handleArrowClick(this.state.nextWebCategory, this.state.nextProduct)}>{icons.renderArrowRightIcon()}</span>
        </div>
        {App.countryCode === 'de' &&
          <div class={styles.info}>
            {i18nService.translate('detail_view_hint_get_more_club')} <a
            href={'/get-more-club'} data-native>{i18nService.translate('detail_view_click_here')}</a>
          </div>}
        <div class={styles.close}>
          <div onClick={() => navigationService.closeDetailView()}>{icons.renderCloseIcon()}</div>
        </div>
      </div>
    )
  }

  private _handleArrowClick(webCategory: string, variant: Variant) {
    let event = {
      label: `${webCategory} - ${variant.productId}`,
      action: 'selectProductViaNavigationArrow',
      category: 'Products',
      isSale: variant.sale ? '1' : '0',
      imageType: (variant.images.find(i => i.position === 0) as Image)?.type
    };
    NY_Tracker.trackClick(event as TrackingEvent);
    navigationService.showDetailView(variant.productId, variant.id)
  }

  findInProducts(productId: string, variantId: string): number {
    let index = 0;
    let found = false;
    for (index; index < this.props.products.items.length; index++) {
      const product = this.props.products.items[index];
      for (const variant of product.variants) {
        if (variant.productId === productId && variant.id === variantId) {
          found = true;
          break
        }
      }
      if (found) {
        break
      }
    }

    return found ? index : -1;
  }

  _calculatePrevious(index: number) {
    let variant;
    let webCategory;
    let product;
    if (index > 0 && this.props.products.totalCount > 1) {
      product = new Product(this.props.products.items[index - 1]);
      webCategory = product.web_category;
      variant = product.getMatchingVariant();
    }

    this.setState(prevState => {
      return {
        previousProduct: variant,
        previousWebCategory: webCategory,
      }
    });
  }

  _calculateNext(index: number) {
    let variant;
    let webCategory;
    let product;
    if (this.props.products.items.length > 0 && this.props.products.items.length > index + 1 && this.props.products.totalCount > index + 1) {
      product = new Product(this.props.products.items[index + 1]);
      webCategory = product.web_category;
      variant = product.getMatchingVariant();
    }

    this.setState({
      nextProduct: variant,
      nextWebCategory: webCategory,
    });
  }
}

export default connect(mapToProps, actions)(Navigation)